module.exports = __webpack_public_path__ + "assets/webgl/art_080_L0.jpg.pvr.2e7f7390.ktx";